<div style="min-height: 70px" *ngIf="selectedData == null" id="CreateAdvContainer">
  <div class="row">
    <div *ngFor="let description of descriptionList; let i = index" class="col categoryBox" [ngClass]="highlightSelectedData(description)" (click)="SelectMainCategory(description, i)" >
<!--      <img src="{{base_url}}{{description.icon}}" alt="">-->
      <label>{{description.label}}</label>
    </div>
  </div>
</div>
